module.exports = __webpack_public_path__ + "static/media/is_landscape_park.7db67860.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_landscape_park.svg
// module id = 1504
// module chunks = 0